<div class="ttmodal" *ngIf="newDG">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Add Dealer Group</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body">

      
      <div class="input-container">
          <span class="" style="width: 165px">Dealer Group Name <span class="red-text">*</span></span>
          <span class="input-icon input-icon--mat">
              <i class="material-icons">location_city</i>
          </span>
          <input [(ngModel)]="dealerGroupName" type="text" placeholder="TrackTreads" required>
      </div>
     


      <span class="input-description">Please select the reports you would like dealerships within this dealer group to be allowed to use. </span>
      <div class="input-container">
          <span class=""style="width: 165px">Condition Report Styles <span class="red-text">*</span></span>
          <mat-select class="get-select-text" placeholder="Select Condition Report Styles"  multiple  [(ngModel)]="reportIds" >
            <mat-option *ngFor="let report of FluidReportList" [value]="report.ReportId">{{ report.ReportName }}
            </mat-option>
          </mat-select>
      </div>

   
      <div class="input-container">
          <span class=""style="width: 165px">Colour Scheme <span class="red-text">*</span></span>
          <span class="input-icon input-icon--mat">
            <i class="material-icons">format_color_fill</i>
        </span>
          <select [(ngModel)]="selectedColourSchemeId" required class="get-Input get-select-text">
            <option value="" disabled selected>Select Colour Scheme</option>
            <option *ngFor="let colourScheme of colourSchemes" [value]="colourScheme.Id">{{colourScheme.Name}}</option>
        </select>
      </div>


      <span class="input-description">Upload a logo for the Dealer Group. Recommended 77px by 35px. <span class="red-text">*</span></span>
      <input type='file' (change)="onSelectImage($event)">
      <div style="margin-top: 8px;">
          <img *ngIf="dealershipLogo" [src]="dealershipLogo" height="70" width="154">
      </div>

      <span class="input-description">Upload a logo that will show on PDF Report. Recommended 77px by 35px. </span>
      <input type='file' (change)="onSelectReportImage($event)">
      <div style="margin-top: 8px;">
          <img *ngIf="dealershipReportLogo" [src]="dealershipReportLogo" height="70" width="154">
      </div>

     
  </div>
  <div class="ttmodal__footer">
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
      <a class="button button--primary" (click)="addNewDealerGroup()" [class.loading]="savingNewDealership"><span class="button__text">Add Dealer Group</span></a>
  </div>
</div>

<div class="ttmodal" *ngIf="!newDG && dealergroupId>0">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Edit Dealer Group</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body">

      
      <div class="input-container">
          <span class=""style="width: 165px">Dealer Group Name <span class="red-text">*</span></span>
          <span class="input-icon input-icon--mat">
              <i class="material-icons">location_city</i>
          </span>
          <input [(ngModel)]="dealerGroupName" type="text" placeholder="TrackTreads" required>
      </div>
     


      <span class="input-description">Please select the reports you would like dealerships within this dealer group to be allowed to use. </span>
      <div class="input-container">
          <span class="" style="width: 165px">Condition Report Styles <span class="red-text">*</span></span>
          <mat-select  placeholder="Select Condition Report Styles"  multiple class="get-select-text" [(ngModel)]="reportIds" >
            <mat-option *ngFor="let report of FluidReportList" [value]="report.ReportId">{{ report.ReportName }}
            </mat-option>
          </mat-select>
      </div>

   
      <div class="input-container">
          <span class="" style="width: 165px">Colour Scheme <span class="red-text">*</span></span>
          <span class="input-icon input-icon--mat">
            <i class="material-icons">format_color_fill</i>
        </span>
          <select [(ngModel)]="selectedColourSchemeId" required class="get-Input get-select-text">
            <option value="" disabled selected>Select Colour Scheme</option>
            <option *ngFor="let colourScheme of colourSchemes" [value]="colourScheme.Id">{{colourScheme.Name}}</option>
        </select>
      </div>


      <span class="input-description">Upload a logo for the Dealer Group. Recommended 77px by 35px. <span class="red-text">*</span></span>
      <input type='file' (change)="onSelectImage($event)">
      <div style="margin-top: 8px;">
          <img *ngIf="dealershipLogo" [src]="dealershipLogo" height="70" width="154">
      </div>

      <span class="input-description">Upload a logo that will show on PDF Report. Recommended 77px by 35px.</span>
      <input type='file' (change)="onSelectReportImage($event)">
      <div style="margin-top: 8px;">
          <img *ngIf="dealershipReportLogo" [src]="dealershipReportLogo" height="70" width="154">
      </div>

     
  </div>
  <div class="ttmodal__footer">
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
      <a class="button button--primary" (click)="UpdateDealerGroup()" [class.loading]="savingNewDealership"><span class="button__text">Update Dealer Group</span></a>
  </div>
</div>